export const carModels = [
    "پژو 405", "سمند", "پرايد", "ال90 تندر", "دنا", "پارس", "تارا", "پژو پارس", "پژو 206"
];

export const brandModels = [
    "ايران کاربراتور IRCA", "پاورگريپ POWERGRIP", "کوجيفا COGEFA", "شوبرت هلند SCHUBERT", "والئو فرانسه VALEO",
    "پرتوناب PNE", "ايساکو ISACO", "اس ام آلمان SM", "ويژن VISIUN", "علمي ساز يدک BABAPART"
];